// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"f386f729","787":"7d7cc43f","886":"e419fab9"}[chunkId] + ".chunk.js";
};